import React from 'react';
import { motion } from 'framer-motion';

const ProductList = ({ products, onEdit, onDelete }) => {
  // Configuração das animações
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };
  
  // Se não houver produtos, exibe mensagem
  if (!products || products.length === 0) {
    return (
      <motion.div 
        className="empty-state"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <p>Nenhum produto cadastrado.</p>
        <p>Clique em "Adicionar Produto" para começar.</p>
      </motion.div>
    );
  }
  
  // Formata valor monetário
  const formatPrice = (price) => {
    return typeof price === 'number'
      ? `R$ ${price.toFixed(2).replace('.', ',')}`
      : 'Preço não disponível';
  };
  
  return (
    <motion.div 
      className="product-list-admin"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="list-header">
        <div>Imagem</div>
        <div>Produto</div>
        <div>Preço</div>
        <div>Ações</div>
      </div>
      
      {products.map((product) => (
        <motion.div 
          key={product.id} 
          className="product-item"
          variants={itemVariants}
        >
          <div className="product-image">
            {product.images && product.images.length > 0 ? (
              <img 
                src={product.images[0].url} 
                alt={product.name}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = 'https://via.placeholder.com/60x60?text=Sem+Imagem';
                }}
              />
            ) : (
              <div className="no-image">Sem imagem</div>
            )}
          </div>
          
          <div className="product-name">
            <h3>{product.name}</h3>
            <p className="product-description">
              {product.description 
                ? (product.description.length > 60 
                    ? `${product.description.substring(0, 60)}...` 
                    : product.description)
                : 'Sem descrição'
              }
            </p>
          </div>
          
          <div className="product-price">
            {formatPrice(product.price)}
          </div>
          
          <div className="product-actions">
            <button 
              className="admin-button edit-button"
              onClick={() => onEdit(product)}
            >
              Editar
            </button>
            <button 
              className="admin-button delete-button"
              onClick={() => onDelete(product.id)}
            >
              Excluir
            </button>
          </div>
        </motion.div>
      ))}
    </motion.div>
  );
};

export default ProductList; 